export default {
  methods: {
    $setCustomSecondMenuButtons () {
      this.$events.$emit("add:custom:secondMenu:buttons",
        this.secondMenu
      )
    }
  }
}
